import { render, staticRenderFns } from "./FirstMessage.vue?vue&type=template&id=08c58c3b&scoped=true"
import script from "./FirstMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./FirstMessage.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FirstMessage.vue?vue&type=style&index=0&id=08c58c3b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c58c3b",
  null
  
)

export default component.exports